<div *ngIf="overview.fullPageError$ | ngrxPush as fullPageError">
  <div
    [error]="fullPageError.error"
    (action)="redirect($event, 'button')"
    auraSkeletonLoader
  ></div>
  <ng-container *ngIf="!fullPageError.error">
    <ng-container *ngIf="overview.welcomeTour$ | ngrxPush as content">
      <idp-welcome-tour
        (closeModal)="close()"
        *ngIf="!content.disabled"
        [content]="content"
      ></idp-welcome-tour>
    </ng-container>
    <idp-overview-page
      *ngIf="{
        onboarding: (overview.onboarding$ | ngrxPush) || emptyOnboarding,
        microMoments: (overview.microMoments$ | ngrxPush) || emptyMicroMoments,
        header: (overview.header$ | ngrxPush) || '',
        summary: (overview.summary$ | ngrxPush) || emptySummary,
        tracker: (tracker.tracker$ | ngrxPush) || emptyTracker,
        status: (overview.status$ | ngrxPush) || emptyStatus,
        cards: (overview.cards$ | ngrxPush) || emptyCards,
        earnsSummary: (overview.earnsSummary$ | ngrxPush) || emptyEarnsSummary,
        skyclubTracker:
          (overview.skyclubTracker$ | ngrxPush) || emptySkyClubTracker,
        quickLinks: (overview.quickLinks$ | ngrxPush) || emptyQuickLinks,
        benefits: (overview.benefits$ | ngrxPush) || emptyBenefits,
        snapshot: (overview.snapshot$ | ngrxPush) || emptySnapshot,
        upgrades: (overview.upgrades$ | ngrxPush) || emptyUpgrades,
        earns: {
          title: (overview.title$ | ngrxPush) || '',
          banner: (overview.banner$ | ngrxPush) || emptyBanner,
          offers: (overview.offers$ | ngrxPush) || emptyOffers,
          partners: (overview.partners$ | ngrxPush) || false,
          relatedLinks: (overview.relatedLinks$ | ngrxPush) || emptyRelatedLinks
        },
        stipulation: (overview.stipulation$ | ngrxPush) || emptyStipulation
      } as content"
      (openLink)="redirect($event, 'link')"
      [content]="content"
    ></idp-overview-page>
  </ng-container>
</div>
